function Inicio() {
  return (
    <div>
      <h1>Inicio</h1>
    </div>
  )
}

export default Inicio;